// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Ux-z","tooltipWrapper":"Vx-z","icon":"Wx-z","tooltip":"Xx-z","content":"Yx-z"};